import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/shared/services/api.service';
import { explode } from './util-functions';
import { isPlatformServer } from '@angular/common';
import { environment } from '../../../environments/environment';

@Injectable()
export class AppInterceptor implements HttpInterceptor {

    dontShowSpinner = [
      "places-autocomplete"
    ];

    constructor( 
      private apiService: ApiService,
      @Inject(PLATFORM_ID) private platformId
    ) {}
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

      var token: string = localStorage.getItem('token');
      const origin = environment.websiteUrl;
      if(token) {
        request = request.clone({
          setHeaders: {
            'token': token,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'website-url' : origin
          }
        });
      }else {
        request = request.clone({
          setHeaders: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'website-url' : origin
          }
        });
      }

      return next.handle(request).pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
          }

          return event;
        }));
    }
}